<template>
    <div class="wrapper" id="app">
        <the-header class="hidden-lg" v-if="!componentHiddenOnRoute"></the-header>
        <div class="wrapper__content">
            <div class="sidebar__background" v-if="!componentHiddenOnRoute"></div>
            <the-sidebar class="visible-lg" v-if="!componentHiddenOnRoute"></the-sidebar>
            <main :class="{no_padding : !showNavigation, main :!componentHiddenOnRoute }">
                <div class="main__inner">
                    <div class="container">
                        <router-breadcrumb v-if="showNavigation" />
                        <router-view></router-view>
                    </div>
                </div>
            </main>
        </div>
        <the-footer :localeHidden="componentHiddenOnRoute"></the-footer>

        <cookie-notification></cookie-notification>
    </div>
</template>

<script>
    import '@mdi/font/css/materialdesignicons.css';
    import Vue from 'vue';
    import { Component } from 'vue-property-decorator';
    import TheFooter from '@/components/general/TheFooter';
    import TheHeader from '@/components/general/TheHeader';
    import TheSidebar from '@/components/general/TheSidebar';
    import CookieNotification from '@/components/cookies/CookieNotification';
    import RouterBreadcrumb from './components/general/RouterBreadcrumb';
    import {IS_AUTHENTICATED} from './store/modules/auth';
    import {FETCH_ACCOUNT_DETAILS} from './store/modules/account_details';
    import {FETCH_INSTALLATION_PROGRESS} from './store/modules/proposal_progress';

    @Component({
        components: {
            TheFooter,
            TheHeader,
            TheSidebar,
            CookieNotification,
            RouterBreadcrumb,
        }
    })
    export default class App extends Vue {
        name = 'app';

        get showNavigation() {
            return !this.$route.path.startsWith('/auth');
        }

        created() {
            // If the user is already authenticated then we trigger the fetch, otherwise the fetch will occur during login
            if (this.$store.getters[IS_AUTHENTICATED]) {
                this.$store.dispatch(FETCH_ACCOUNT_DETAILS);
                this.$store.dispatch(FETCH_INSTALLATION_PROGRESS);
            }
        }
        get componentHiddenOnRoute(){
            return ['activate', 'sign-in', 'reset', 'reset/token'].includes(this.$route.name);
        }
    }
</script>

<!-- Import SCSS boilerplate -->
<style src="./assets/css/styles.scss" lang="scss"></style>




// WEBPACK FOOTER //
// src/App.vue